// permissions.ts — katalog uprawnień Control Center.
//
// ==========================================================================================
//  TWARDA ZASADA BEZPIECZEŃSTWA (R5-15 §21)
//  Ukrycie elementu w interfejsie NIE JEST autoryzacją.
//  Ten moduł steruje WYŁĄCZNIE tym, co użytkownik widzi. Jedyną autoryzacją, która się liczy,
//  jest kontrola po stronie backendu. Jeżeli kiedykolwiek pojawi się endpoint chroniony tylko
//  tym plikiem — to jest luka bezpieczeństwa, nie funkcja.
// ==========================================================================================
//
// Model jest zorientowany na UPRAWNIENIA, nie na role. Role są tylko wygodnym opakowaniem,
// bo backendy TuSzamy dziś operują rolami (crm_admin, notification_templates, admin, subadmin,
// DELIVER…). Mapowanie rola → uprawnienia jest w roleMap.ts i to ono jest tymczasowe.

export const PERMISSIONS = [
  'analytics.sales.read',
  'analytics.delivery.read',
  'admin.users.read',
  'admin.users.write',
  'restaurant.menu.read',
  'restaurant.menu.write',
  'restaurant.sales.read',
  'crm.campaigns.read',
  'crm.campaigns.write',
  'crm.customers.read',
  'drive.routes.read',
  'drive.deliveries.read',
  'reports.read',
  'system.incidents.read',
  'system.audit.read',
] as const;

export type Permission = (typeof PERMISSIONS)[number];

export type PermissionSet = ReadonlySet<Permission>;

export function makePermissionSet(list: readonly Permission[]): PermissionSet {
  return new Set(list);
}

export const EMPTY_PERMISSIONS: PermissionSet = new Set<Permission>();

/** Czy zestaw uprawnień pokrywa WSZYSTKIE wymagane. Brak wymagań = dostęp otwarty. */
export function can(granted: PermissionSet, required: readonly Permission[] | undefined): boolean {
  if (!required || required.length === 0) return true;
  return required.every((p) => granted.has(p));
}

/** Czy zestaw pokrywa CHOĆ JEDNO z wymaganych (nawigacja: pokaż zakładkę, jeśli cokolwiek widać). */
export function canAny(granted: PermissionSet, required: readonly Permission[] | undefined): boolean {
  if (!required || required.length === 0) return true;
  return required.some((p) => granted.has(p));
}
